import stl from "./SubMenuContainer.module.css";
import {CDN_LINK} from "@globalConfig";
import {useTranslation} from "@i18n";
import useIsBrowser from "@hooks/useIsBrowser";

function SubMenuContainer(
    {
        name,
        onClick,
        component,
        count,
        selectedFiltersCount,
        handleCloseFilter,
    }) {
    const {t} = useTranslation();
    const canUseDOM = useIsBrowser();
    return (
        <div className={stl.container}>
            <div
                className={[stl.headingPart].join(" ")}
                onClick={handleCloseFilter}
            >
                <img
                    className={"m-hide"}
                    src={CDN_LINK + "/assets/images/arrAcc.svg"}
                    width={12}
                    height={7}
                    alt="arrow"
                />
                <span className={[stl.backMob, "m-show"].join(" ")}>
            {t("إلغاء")}
          </span>
                <strong>{name}</strong>
            </div>

            <div
                className={[
                    stl.componentContainer,
                    canUseDOM &&
                    document.getElementById("LineCamp") != null &&
                    window.innerWidth > 1024 &&
                    document.getElementById("LineCamp").style.display != "none"
                        ? stl.campHeight
                        : undefined,
                ].join(" ")}
            >
                {component}
            </div>
            {!(count == 0 && selectedFiltersCount > 0) && (
                <button onClick={onClick} className={stl.DoneBtn}>
                    {t("تم")}
                </button>
            )}
        </div>
    );
}

export default SubMenuContainer;
